$ = require('jquery')
config = require('@trello/config')

$(document).ajaxSend (e, xhr, settings) ->
  # We only want to set this header on local requests, otherwise we'll break
  # things like loading off domain plugins
  if settings.url.indexOf('/') == 0
    xhr.setRequestHeader('X-Trello-Client-Version', config.clientVersion)
  return
